import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[trimOnBlur], textarea[trimOnBlur]',
  standalone: false,
})
export class TrimOnBlurDirective {
  private ngControl = inject(NgControl, { optional: true });

  @HostListener('blur')
  onBlur(): void {
    const control = this.ngControl?.control;
    const value = control?.value;

    if (typeof value !== 'string') {
      return;
    }

    const trimmedValue = value.trim();
    if (trimmedValue !== value) {
      control.setValue(trimmedValue);
    }
  }
}
